import script from "./VehicleTab2.vue?vue&type=script&setup=true&name=BasicInfoTab&lang=js"
export * from "./VehicleTab2.vue?vue&type=script&setup=true&name=BasicInfoTab&lang=js"

import "./VehicleTab2.vue?vue&type=style&index=0&id=2b854508&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b854508"]])

export default __exports__